/**
 @ngdoc service
 @name mapCandidateTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict'

    var mapCandidateTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){

            const iconPath = `${WEBAPP_PATH}/images/svg/`
            const candidateIcon = `${iconPath}icons-candidate-10-6-1.svg#`

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData)

            // Adding labels to column structured data
            tileFactory.addFieldToColumn1(tileFactory.field.newField('id'))

            // Phone number field data
            const phoneField = tileFactory.field.newInactiveFieldAjax('mobile', 'mobileOptout', 'mobileOptout', 'actionLogURI','logPhoneCall')
            // Set icon based on active status
            const phoneIcon = phoneField.inactive ? 'icon-phone-blocked' : 'icon-phone'
            // Active number can be clicked so link is used, unactive number link is removed
            phoneField.link = phoneField.inactive ? undefined : phoneField.link
            // Display the phone number or the opt-out message on the tooltip
            phoneField.additionalInfo = phoneField.inactive ? phoneField.additionalInfo : phoneField.value
            // Add icon to field
            tileFactory.addFieldToColumn1(tileFactory.addIcon(candidateIcon, phoneIcon, phoneField, true))

            // Email field data
            const emailField = tileFactory.field.newInactiveWarningField('email', ['invalidEmailWarning', 'spamEmailWarning'], 'emailOptout', 'emailOptout', 'actionLogURI')
            // Set icon based on validity or active status
            const emailIcon = emailField.warning ? 'icon-email-invalid' : emailField.inactive ? 'icon-email-blocked' : 'icon-email'
            // Active email can be clicked co set a link
            emailField.link = emailField.inactive || emailField.warning ? undefined : tileFactory.field.newEmailLink(emailField.value)
            // Display the email or the opt-out message on the tooltip
            emailField.additionalInfo = emailField.inactive ? emailField.additionalInfo : emailField.value
            // Add icon to field
            tileFactory.addFieldToColumn1(tileFactory.addIcon(candidateIcon, emailIcon, emailField, true))

            // Whatsapp field data
            const whatsAppField = tileFactory.field.newField('whatsAppOptout')
            const whatsAppFieldIcon = rawTileData.whatsAppOptout ? 'icon-whatsapp-blocked' : 'icon-whatsapp'
            const whastAppFieldStatus = `Candidate has opted ${rawTileData.whatsAppOptout ? 'out of' : 'into'} WhatsApp`
            whatsAppField.value = whastAppFieldStatus
            whatsAppField.additionalInfo = whastAppFieldStatus
            tileFactory.addFieldToColumn1(tileFactory.addIcon(candidateIcon, whatsAppFieldIcon, whatsAppField, true))

            tileFactory.addFieldToColumn2(tileFactory.addIcon(candidateIcon, 'icon-address', tileFactory.field.newAddressField('town')))

            if(rawTileData.distanceFromSearch != null && rawTileData.distanceFromSearch !== undefined){
                const fieldObject = tileFactory.field.newField('distanceFromSearch')
                if(rawTileData.isDistFromSearchHigherThanJobRadius) {
                    fieldObject.additionalInfo = objectTilesLabels['distIsInaccurate'].label
                    fieldObject.classList = ['text-danger']
                } else {
                    fieldObject.additionalInfo = objectTilesLabels['distIsAccurate'].label
                    fieldObject.classList = ['text-success']
                }
                tileFactory.addFieldToColumn2(fieldObject)
            }
            if (rawTileData.timeFromSearch != null || rawTileData.timeFromSearch !== undefined) {

                const fieldObject = tileFactory.addIcon(
                                                  '',
                                                  rawTileData.timeIcon,
                                                  tileFactory.field.newField('timeFromSearch'), false, true
                                                  );
                                                tileFactory.addFieldToColumn2(fieldObject);
            }

            tileFactory.addFieldToColumn2(tileFactory.field.newField('lastCvUpdated', 'dateTime'))

            tileFactory.addFieldToColumn3(
                tileFactory.addIcon(
                    candidateIcon,
                    'icon-target-salary',
                    tileFactory.field.newRatePerUnitField(
                        'targetSalary',
                        rawTileData.targetSalaryType.id,
                        lookupValues[rawTileData.targetSalaryType.lookupKey][rawTileData.targetSalaryType.id],
                    ),
                ),
            )

            tileFactory.addFieldToColumn3(
                tileFactory.addIcon(
                    candidateIcon,
                    'icon-interim-rate',
                    tileFactory.field.newRatePerUnitField(
                        'interimRate',
                        rawTileData.interimRateType.id,
                        lookupValues[rawTileData.interimRateType.lookupKey][rawTileData.interimRateType.id],
                    ),
                ),
            )

          const jobKey = 'findScoreDetailForJobURI'
          const candidateKey = 'findCandidateMatchDetailForGivenCandidateURI'
          let scoreDetailsUriKey = rawTileData[jobKey]
            ? jobKey : rawTileData[candidateKey]
              ? candidateKey
              : '';

          tileFactory.addFieldToColumn3(tileFactory.field.newStarRatingField(
            'matchedToJobScore',
            'matchedToJobScoreInfo',
            null,
            scoreDetailsUriKey
          ))

            tileFactory.addFieldToColumn4(tileFactory.field.newField('lastLogin', 'dateTime'))
            tileFactory.addFieldToColumn4(tileFactory.field.newField('lastContact', 'dateTime'))

            // Adding status to tile data
            tileFactory.addStatus(tileFactory.status.newStatusWithHelp('employmentType','employmentTypeHelp'))

            // WhatsApp converstion tile
            const socialIcon = `${iconPath}icons-social.svg#`
            const hasActiveConversation = JSON.parse(rawTileData.hasActiveWhatsappConversation)
            const hasUnreadMessage = JSON.parse(rawTileData.newWhatsappMessage)
            const hasActiveConversationWithUnread = hasActiveConversation && hasUnreadMessage
            const hasInactiveConversationWithUnread = !hasActiveConversation && hasUnreadMessage
            if (hasActiveConversation || hasUnreadMessage) {
                const whatsAppIcon = `icon-whatsapp-${
                    hasActiveConversationWithUnread ? 'active-unread' :
                    hasInactiveConversationWithUnread ? 'inactive-unread' :
                    'active'
                }`
                const whatsAppMessage = `Candidate has ${hasActiveConversation ? 'active' : 'inactive'} WhatsApp conversation${hasUnreadMessage ? ' with unread message' : ''}`
                tileFactory.addStatus(tileFactory.status.newStatusIcon('hasActiveWhatsappConversation', socialIcon, whatsAppIcon, whatsAppMessage))
            }

            // TODO: fix "entitlementToWork"
            tileFactory.addStatus(tileFactory.status.newLabelAndBooleanValueStatus('entitlementToWork'))
            if (rawTileData.complianceStatusLookupValId != null) {
                tileFactory.addStatus(tileFactory.status.newStatus('complianceStatusLookupValId'))
            }

            // 719: "Available"
            // 721: "Not looking for work"
            // 722: "In booking"
            // 723: "In booking via competitor"
            // 724: "In booking via client supplied"
            // 4591: "Unknown"
            // 5364: "Prospective"
            // 434496: "Stopped"
            // 434920: "Self Suited"
            // 434921: "On Hold"
            if( rawTileData.availability.id !=null ) {
                tileFactory.addStatus(tileFactory.status.newStatusWithInfoAndStyling('availability', 'availabilityHelp',
                    // Positives
                    [
                        tileFactory.LOOKUP_VALUE.AVAILABILITY_PROSPECTIVE,
                    ],
                    // Negatives
                    [
                        tileFactory.LOOKUP_VALUE.AVAILABILITY_RTFS,
                        tileFactory.LOOKUP_VALUE.AVAILABILITY_IN_BOOKING_PERM,
                        tileFactory.LOOKUP_VALUE.AVAILABILITY_NOT_LOOKING_FOR_WORK,
                        tileFactory.LOOKUP_VALUE.AVAILABILITY_STOPPED,
                    ],
                    // Warning
                    [
                        tileFactory.LOOKUP_VALUE.AVAILABILITY_IN_BOOKING_TEMP,
                    ]))
            }

            tileFactory.addStatus(tileFactory.status.newTrueBooleanOrHide('validComplianceCertificate', 'success'))

            tileFactory.addStatus(tileFactory.status.newLabelStatus('previousRtfs'))
            if(rawTileData.emailPermission === true) {
                tileFactory.addStatus(tileFactory.status.newLabelStatus('invalidEmailStatus', 'invalidEmailWarning'))
                tileFactory.addStatus(tileFactory.status.newLabelStatus('invalidSpamStatus', 'spamEmailWarning'))
            }

            var callToHistoryModel = tileFactory.callToAction.newCallToActionModal('recentHistory', 'recentHistory')
            tileFactory.addCallToAction(callToHistoryModel)

            var callToActionModel = tileFactory.callToAction.newCallToActionModal('defaultCV', 'defaultCVURI')
            if(callToActionModel) {
                callToActionModel.title = objectTilesLabels.defaultCVButtonToolTip.label
            }
            tileFactory.addCallToAction(callToActionModel)

            tileFactory.addSearchMatchFlag(tileFactory.searchMatchFlag.newSearchMatchFlag('cvMatch', 'cvMatchToolTip'))

            return tileFactory.tileData
        }

        return {
            map : map,
        }
    }

    mapCandidateTileService.$inject = ['tileDataFactory']
    angular.module('app').factory('mapCandidateTileService', mapCandidateTileService)
// eslint-disable-next-line semi
}());

